import React, { Component } from "react";
import { espotAPI, imagePrefix } from "../../../public/constants/constants";
import apiManager from "../../utils/apiManager";
import { isMobile } from "../../utils/utilityManager";
import "../../../public/styles/HomeInteriors/basicBanner.scss";
import FormBody from "./OrphanPage/FormBody";

export default class HIBasicBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      espotName: this.props.espotName,
      bannerImg: "",
      buttontext: "",
      title1: "",
      title2: "",
      MobBannerImg: "",
      showModal: false,
    };
  }

  closeModal = () => {
    this.setState({
      showModal: false,
    });
  };

  modalOpenHandler = () =>{
    this.setState({
      showModal: true,
    });
  }

  getEspotData() {
    apiManager
      .get(espotAPI + this.state.espotName)
      .then(response => {
        const { data } = response || {};
        this.setState({
          bannerImg: data && data.data.bannerImg,
          buttontext: data && data.data.buttontext,
          title1: data && data.data.title1,
          title2: data && data.data.title2,
          MobBannerImg: data && data.data.MobBannerImg,
        });
      })
      .catch(error => {
        this.setState({
          error,
          isLoading: false,
        });
      });
  }

  componentDidMount() {
    this.getEspotData();
  }

  render() {
    return (
      <div className="HIbasic-banner-container">
        <div className="banner-wrapper">
          <div className="bannerimg-container">
            <div className="bannerimg-wrapper">
              {isMobile() ? (
                <img src={imagePrefix + this.state.MobBannerImg} />
              ) : (
                <img src={imagePrefix + this.state.bannerImg} />
              )}
              {/* <img src={imagePrefix + this.state.bannerImg} /> */}
              <div className="banner-overlay" />
            </div>
          </div>
          <div className="banner-text-container">
            <div className="banner-text-wrapper">
              <h1>{this.state.title1}</h1>
              <h3>{this.state.title2}</h3>
              {this.props.buttontext == "" ? (
                <></>
              ) : (
                <>
                  <div>
                    <button onClick={this.modalOpenHandler.bind(this)}>{this.state.buttontext}</button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {this.state.showModal ? (
          <>
            <FormBody
              // class="modal-orphan-form"
              source
              pageSource = {this.props.pageSource}
              closeModal={this.closeModal.bind(this)}
            />
          </>
        ) : (
          <></>
        )}
      </div>
    );
  }
}
